<div mat-dialog-title style="display:flex;align-items:center;justify-content:space-between">
  <span style="display:flex;align-items:center;gap:6px">
    <mat-icon class="warning-icon">warning</mat-icon>
    Confirmar eliminación
  </span>
  <button mat-icon-button (click)="onCancel()" aria-label="Cerrar" style="flex-shrink:0">
    <mat-icon>close</mat-icon>
  </button>
</div>

<mat-dialog-content>
  <p class="confirmation-message">
    ¿Está seguro de que desea eliminar al personal <strong>{{ data.staffName }}</strong>?
  </p>
  <p class="warning-text">
    <mat-icon>info</mat-icon>
    Esta acción no se puede deshacer. El personal será eliminado permanentemente y se desasignará de todos los conceptos.
  </p>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="onCancel()">
    Cancelar
  </button>
  <button mat-raised-button color="warn" (click)="onConfirm()">
    Eliminar
  </button>
</mat-dialog-actions>
